export const Colors = {
    "earths": {
        "white": {
            "base": "#bdbdbd",
            "mid": "#ffffff",
            "bright": "#ffffff",
            "highlight": "#ffffff",
            "pastel": "#ffffff",
            "compliment": "#ffffff"
        },
        "earths-1": {
            "base": "#9d5c51",
            "mid": "#cd432c",
            "bright": "#FC2907",
            "highlight": "#ff4220",
            "pastel": "#d99a90",
            "compliment": "#07dafc"
        },
        "earths-2": {
            "base": "#99556e",
            "mid": "#c53369",
            "bright": "#F01064",
            "highlight": "#ff297d",
            "pastel": "#d491ab",
            "compliment": "#10f09c"
        },
        "earths-3": {
            "base": "#8d5279",
            "mid": "#b53388",
            "bright": "#DD1396",
            "highlight": "#ff23b2",
            "pastel": "#ce88b5",
            "compliment": "#13dd5a"
        },
        "earths-4": {
            "base": "#8d6594",
            "mid": "#a058ad",
            "bright": "#B34BC5",
            "highlight": "#d35be7",
            "pastel": "#c7aacc",
            "compliment": "#5dc54b"
        },
        "earths-5": {
            "base": "#786ab9",
            "mid": "#7461ce",
            "bright": "#7058E3",
            "highlight": "#876eff",
            "pastel": "#c5c0e1",
            "compliment": "#cbe358"
        },
        "earths-6": {
            "base": "#5d78a7",
            "mid": "#4d79c3",
            "bright": "#3D7ADF",
            "highlight": "#4f91ff",
            "pastel": "#abbbd7",
            "compliment": "#dfa23d"
        },
        "earths-7": {
            "base": "#4c7685",
            "mid": "#2e8eae",
            "bright": "#0FA5D7",
            "highlight": "#1cc4fb",
            "pastel": "#7fb9cd",
            "compliment": "#d7410f"
        },
        "earths-8": {
            "base": "#417274",
            "mid": "#23989c",
            "bright": "#05BEC4",
            "highlight": "#11e3ea",
            "pastel": "#66c6c9",
            "compliment": "#c40b05"
        },
        "earths-9": {
            "base": "#467d74",
            "mid": "#28a792",
            "bright": "#0AD0B0",
            "highlight": "#17f5d1",
            "pastel": "#75cbbd",
            "compliment": "#d00a2a"
        },
        "earths-10": {
            "base": "#46806c",
            "mid": "#26ad7e",
            "bright": "#05DA90",
            "highlight": "#12ffad",
            "pastel": "#76cfb0",
            "compliment": "#da054f"
        },
        "earths-11": {
            "base": "#3f765f",
            "mid": "#20a06b",
            "bright": "#00C977",
            "highlight": "#0cef92",
            "pastel": "#63cba1",
            "compliment": "#c90052"
        },
        "earths-12": {
            "base": "#5f995e",
            "mid": "#56b554",
            "bright": "#4CD149",
            "highlight": "#5cf359",
            "pastel": "#aed3ad",
            "compliment": "#ce49d1"
        },
        "earths-13": {
            "base": "#718a56",
            "mid": "#7bb33c",
            "bright": "#84DC22",
            "highlight": "#9eff31",
            "pastel": "#b4ce96",
            "compliment": "#7a22dc"
        },
        "earths-14": {
            "base": "#788348",
            "mid": "#99b228",
            "bright": "#BAE008",
            "highlight": "#d7ff1b",
            "pastel": "#c2d07e",
            "compliment": "#2e08e0"
        },
        "earths-15": {
            "base": "#91894a",
            "mid": "#c8b625",
            "bright": "#FFE300",
            "highlight": "#fffc19",
            "pastel": "#d9d18d",
            "compliment": "#001cff"
        },
        "earths-16": {
            "base": "#9b7d52",
            "mid": "#c68a37",
            "bright": "#F0961B",
            "highlight": "#ffaf34",
            "pastel": "#d7bd99",
            "compliment": "#1b75f0"
        },
        "earths-17": {
            "base": "#936f55",
            "mid": "#bf6f35",
            "bright": "#EB6E14",
            "highlight": "#ff872d",
            "pastel": "#d3ad93",
            "compliment": "#1491eb"
        },
        "earths-18": {
            "base": "#91644d",
            "mid": "#c05d29",
            "bright": "#EF5504",
            "highlight": "#ff6e1d",
            "pastel": "#d4a084",
            "compliment": "#049eef"
        },
        "earths-19": {
            "base": "#996454",
            "mid": "#c45634",
            "bright": "#EF4713",
            "highlight": "#ff602c",
            "pastel": "#d5a393",
            "compliment": "#13bbef"
        }
    },
    "mids": {
        "mids-1": {
            "base": "#cb4c38",
            "mid": "#FC2907",
            "bright": "#ff3614",
            "highlight": "#ff4220",
            "pastel": "#d99a90",
            "compliment": "#14ddff"
        },
        "mids-2": {
            "base": "#c33d6f",
            "mid": "#F01064",
            "bright": "#ff1b70",
            "highlight": "#ff297d",
            "pastel": "#d491ab",
            "compliment": "#1bffaa"
        },
        "mids-3": {
            "base": "#b53b8a",
            "mid": "#DD1396",
            "bright": "#f614a7",
            "highlight": "#ff23b2",
            "pastel": "#ce88b5",
            "compliment": "#14f663"
        },
        "mids-4": {
            "base": "#a263ad",
            "mid": "#B34BC5",
            "bright": "#c74ddd",
            "highlight": "#d951f1",
            "pastel": "#c7aacc",
            "compliment": "#63dd4d"
        },
        "mids-5": {
            "base": "#8274c7",
            "mid": "#7058E3",
            "bright": "#775df8",
            "highlight": "#876eff",
            "pastel": "#c5c0e1",
            "compliment": "#def85d"
        },
        "mids-6": {
            "base": "#5d82bf",
            "mid": "#3D7ADF",
            "bright": "#4085f6",
            "highlight": "#4f91ff",
            "pastel": "#abbbd7",
            "compliment": "#f6b140"
        },
        "mids-7": {
            "base": "#3791af",
            "mid": "#0FA5D7",
            "bright": "#0fb8f1",
            "highlight": "#19c5ff",
            "pastel": "#7fb9cd",
            "compliment": "#f1480f"
        },
        "mids-8": {
            "base": "#2b9a9e",
            "mid": "#05BEC4",
            "bright": "#07d6dc",
            "highlight": "#05eef6",
            "pastel": "#66c6c9",
            "compliment": "#dc0d07"
        },
        "mids-9": {
            "base": "#32a895",
            "mid": "#0AD0B0",
            "bright": "#0be9c5",
            "highlight": "#0dffd8",
            "pastel": "#75cbbd",
            "compliment": "#e90b2f"
        },
        "mids-10": {
            "base": "#2faf83",
            "mid": "#05DA90",
            "bright": "#06f3a1",
            "highlight": "#12ffad",
            "pastel": "#76cfb0",
            "compliment": "#f30658"
        },
        "mids-11": {
            "base": "#28a16f",
            "mid": "#00C977",
            "bright": "#02e186",
            "highlight": "#00fb95",
            "pastel": "#63cba1",
            "compliment": "#e1025d"
        },
        "mids-12": {
            "base": "#66b664",
            "mid": "#4CD149",
            "bright": "#4fe84c",
            "highlight": "#54fc50",
            "pastel": "#aed3ad",
            "compliment": "#e54ce8"
        },
        "mids-13": {
            "base": "#82b747",
            "mid": "#84DC22",
            "bright": "#92f424",
            "highlight": "#9eff31",
            "pastel": "#b4ce96",
            "compliment": "#8624f4"
        },
        "mids-14": {
            "base": "#9eb533",
            "mid": "#BAE008",
            "bright": "#cffa08",
            "highlight": "#d7ff1b",
            "pastel": "#c2d07e",
            "compliment": "#3308fa"
        },
        "mids-15": {
            "base": "#ccbb33",
            "mid": "#FFE300",
            "bright": "#fff00d",
            "highlight": "#fffc19",
            "pastel": "#d9d18d",
            "compliment": "#0d1cff"
        },
        "mids-16": {
            "base": "#c58f45",
            "mid": "#F0961B",
            "bright": "#ffa326",
            "highlight": "#ffaf34",
            "pastel": "#d7bd99",
            "compliment": "#2682ff"
        },
        "mids-17": {
            "base": "#c0753f",
            "mid": "#EB6E14",
            "bright": "#ff7a1a",
            "highlight": "#ff872d",
            "pastel": "#d3ad93",
            "compliment": "#1a9fff"
        },
        "mids-18": {
            "base": "#c06333",
            "mid": "#EF5504",
            "bright": "#ff610e",
            "highlight": "#ff6e1d",
            "pastel": "#d4a084",
            "compliment": "#0eacff"
        },
        "mids-19": {
            "base": "#c35e3f",
            "mid": "#EF4713",
            "bright": "#ff521d",
            "highlight": "#ff602c",
            "pastel": "#d5a393",
            "compliment": "#1dcaff"
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/LessonBuilder/ColorSchemes/colorschemes.js